module.exports = __webpack_public_path__ + "static/media/logo-buywow-2020_native_shopify.84bf90e0.png";